import { render, staticRenderFns } from "./PublishListIcon.vue?vue&type=template&id=64203a0a&"
import script from "./PublishListIcon.vue?vue&type=script&lang=js&"
export * from "./PublishListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports